module.exports = __webpack_public_path__ + "img/Tools-icon.d6b10bba.svg";